module.exports = __webpack_public_path__ + "static/media/ Dan Limbago Headshot_1666007732095.a0190301.png";